import $ from 'jquery';
import { getParams } from '../util/url';
export var initAutoValidation = function initAutoValidation() {
  // TODO: other selectors
  if ($('[data-autovalidate]').length) {
    import(
    /* webpackChunkName: "form-validator" */
    './validator').then(function (module) {
      return module.default();
    }) // eslint-disable-next-line no-unused-vars
    .catch(function (error) {
      return 'An error occurred while loading form-validtator';
    });
  }
};
export var initDatepickers = function initDatepickers() {
  // TODO: other selectors
  if ($('[data-provide="datepicker"]').length) {
    import(
    /* webpackChunkName: "datepicker" */
    './datepicker') // eslint-disable-next-line no-unused-vars
    .catch(function (error) {
      return 'An error occurred while loading datepickers';
    });
  }
};
export var initSliders = function initSliders() {
  if ($('.slider-date, .slider-dollar, .slider-mile').length) {
    import(
    /* webpackChunkName: "sliders" */
    './sliders').then(function (module) {
      return module.default();
    }) // eslint-disable-next-line no-unused-vars
    .catch(function (error) {
      return 'An error occurred while loading sliders';
    });
  }
};
export var initTelinput = function initTelinput() {
  if ($('#phone-format').length) {
    import(
    /* webpackChunkName: "intl-tel-input" */
    './intl-tel-input').then(function (module) {
      return module.default();
    }) // eslint-disable-next-line no-unused-vars
    .catch(function (error) {
      return 'An error occurred while loading sliders';
    });
  }
};
export var initAutoPopulateFields = function initAutoPopulateFields() {
  // auto populate a form field with a value passed in a query param
  $('[data-autopopulate]').each(function (index, el) {
    el = $(el);
    var param = el.attr('data-autopopulate');

    if (!param || param === 'true' || param === '1') {
      param = 'source';
    }

    var value = getParams()[param] || '';
    el.val(value);
  });
};
export default (function () {
  initAutoPopulateFields();
  initAutoValidation();
  initDatepickers();
  initSliders();
  initTelinput();
});